<template>
  <div>
    <v-sheet  v-if="mostraLinkAssociazione" class="pa-12 mt-3" color="grey lighten-4">
      <v-tabs dense v-model="tab" @change="onChangeTab">
        <v-tab v-for="(item) in elencoLicenze" :key="item.codice" class="licenzaSelected">{{ item.title }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item) in elencoLicenze" :key="item.codice">
          <v-container class="mt-5">
            <v-row>
              <v-col md="3">
                <qrcode-vue :value="getLinkAssociazione(item)" :size="sizeQr" level="M" />
                <!-- <div>{{linkBreveAssociazioneDispositivo}}</div> -->
              </v-col>
              <v-col md="6">
                <h3>Associazione dispositivo per {{ item.title }}</h3>
                <h4 class="mb-5">{{ item.description }}</h4>
                <v-btn color="primary" class="mb-2 mt-5" @click="onGeneraCodiceBreve" title="Permette l'associazione di dispositivi che non possono leggere il QR code">Genera codice breve</v-btn>
                <template v-if="mostraCodiceBreve">
                  <h3>Utilizzare il codice seguente per associare il dispositivo (ha validità 5 minuti)</h3>
                  <v-text-field outlined readonly class="mt-5 text--center" loading :value="codiceBreve">
                    <template v-slot:progress>
                      <v-progress-linear
                        :value="progress"
                        :color="color"
                        absolute
                        height="7"
                      ></v-progress-linear>
                    </template>
                  </v-text-field>
                </template>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn color="secondary" class="mb-2" @click="onAnnullaAssociaDispositivo">Annulla</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>

<!--       <v-container>
        <v-row>
          <v-col md="3">
            <qrcode-vue :value="linkAssociazioneDispositivo" :size="sizeQr" level="M" />
            <div>{{linkBreveAssociazioneDispositivo}}</div>
          </v-col>
          <v-col md="8">
            <h3>Leggi il QRCode con il dispositivo che vuoi associare alla licenza</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="secondary" class="mb-2" @click="onAnnullaAssociaDispositivo">Annulla</v-btn>
          </v-col>
        </v-row>
      </v-container> -->
    </v-sheet>
    <v-data-table
      v-model="selected"
      color="blue lighten-4"
      item-key="codiceAssociazione"
      :headers="headers"
      :items="associazioniSorted"
      :options.sync="options"
      :loading="loading"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Associazione dispositivi</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="mostraAssocia" color="secondary" class="mb-2" :disabled="mostraLinkAssociazione" @click="onAssociaDispositivo">Associa dispositivo</v-btn>
        <v-btn v-if="mostraDisassocia" color="warning" class="mb-2" @click="onCancellaAssociazione" title="Viene inserito l'istante di Off per l'associazione">Cancella associazione</v-btn>
        <h3 v-if="mostraScaduta" class="mb-2 red--text" readonly>Licenza scaduta. Nessuna operazione possibile !</h3>

        <v-dialog v-model="dialogCancellaAssociazione" max-width="600px">
          <v-card>
            <v-card-title class="text-h5">Confermi cancellazione associazione dispositivo?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="upmapConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="unmapClose">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <dialog-errore :show="dialogErrore" title="Errore associazione dispositivo" />
      </v-toolbar>
    </template>    
    <template v-slot:[`item.istanteOn`]="{ item }">
      {{ item.istanteOn | dateTime }}
    </template>
    <template v-slot:[`item.istanteOff`]="{ item }">
      {{ item.istanteOff | dateTime }}
    </template>
    </v-data-table>
  </div>
</template>

<script>
  import DialogErrore from '@/components/dialogErrore'
  import QrcodeVue from '@/plugins/qrcode/qrcode.vue.js'
  const crypto = require('crypto');
  //  "note": "su dettagli licenza: dispositivo associato, date in /out, operatori associati"

  export default {
    components: {
      DialogErrore,
      QrcodeVue
    },
    props: {
      moduli: Array,
      codice: String,
      apikey: String,
      associazioni: Array,
      statoLicenza: Object,
      statoAssociazione: Object,
      refresh: Number
    },
    data: () => ({
      selected: [],
      loading: false,
      options: {},
      headers: [
        { text: 'Codice', value: 'codiceAssociazione', align: 'start'},
        { text: 'UDID dispositivo', value: 'udid' },
        { text: 'OS', value: 'info.os' },
        { text: 'App', value: 'info.appVersion' },
        { text: 'Attivo', value: 'attivo' },
        { text: 'Istante On', value: 'istanteOn' },
        { text: 'Istante Off', value: 'istanteOff' }
      ],      
      filtri: null,
      causali: [],
      dialogCancellaAssociazione: false,
      dialogErrore: false,
      sizeQr: 200,
      mostraLinkAssociazione: false,
      // rndSalt: '',
      codiceBreve: '',
      mostraCodiceBreve: false,
      progress: 100,
      timer: null,
      tab: {},
      elencoAssociazioni: [
        { 
          title: 'App comande',
          description: 'Applicazione per la gestione delle comande in ambiente ristorazione.',
          type: 'app-comande',
          licenza: 'palmari'
        },
        { 
          title: 'Planner',
          description: 'Applicazione per la gestione degli appuntamenti.',
          type: 'planner',
          licenza: 'planner'
        },
        { 
          title: 'Impronto',
          description: 'Versione mobile dell\'interfaccia completa Impronto',
          type: 'impronto',
          licenza: 'ristorazione'
        },
        { 
          title: 'Mobile platform',
          description: 'Applicazione per la gestione del picking, dell\'inventario e degli ordini in mobilità',
          type: 'mobile',
          licenza: 'mobile_platform'
        }
      ]
    }),
    watch: {
      async refresh() {
        this.mostraLinkAssociazione = false
      }
    },
    computed: {
      mostraAssocia() {
        return ['libera'].includes(this.statoAssociazione.codice) && ['attiva', 'inattiva', 'demo'].includes(this.statoLicenza.codice)
      },
      mostraDisassocia() {
        return ['associata'].includes(this.statoAssociazione.codice) && ['attiva', 'inattiva', 'demo'].includes(this.statoLicenza.codice)
      },
      mostraScaduta() {
        return ['scaduta'].includes(this.statoLicenza.codice)
      },
      linkAssociazioneDispositivo() {
        // Punta all'app fallback-app-comande, su sellogic ma con indirizzo ubico  --> da cambiare !!!!
        return `https://impronto.ubi-co.com?code=${this.codice}&key=${this.apikey}`
      },
      linkBreveAssociazioneDispositivo() {
        // Separare per le varie app. Se WebApp deve puntare direttamente all'url dell'app. Es. planner
        return `https://impronto.ubi-co.com?cb=${this.codiceBreve}`
      },      
      associazioniSorted() {
        return _.sortBy(this.associazioni, 'IstanteOn').reverse()
      },
      elencoLicenze() {
        return this.elencoAssociazioni.filter(x => this.moduli.includes(x.licenza) )
      },
      color () {
        return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
      }
    },
    async mounted() {
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.$emit('polling', false, this.codice)
    },    
    methods: {
      getLinkAssociazione(item) {
        switch (item.type) {
          case 'app-comande':
            // Punta all'app fallback-app-comande, su sellogic ma con indirizzo ubico  --> da cambiare !!!!
            return `https://impronto.ubi-co.com?code=${this.codice}&key=${this.apikey}&type=${item.type}`
          case 'planner':
            return `https://planner.impronto.sellogic.cloud?code=${this.codice}&key=${this.apikey}&type=${item.type}`
          case 'impronto':
            return ''
          case 'mobile':
            return ''            
          default:
            break
        }
      },
      onGeneraCodiceBreve() {
        this.mostraCodiceBreve = !this.mostraCodiceBreve
        if (this.mostraCodiceBreve) {
          this.progress = 100
          this.generaCodiceBreve()
          this.timer = setInterval(() => {
            this.progress--
            if (this.progress === 0) {
              this.generaCodiceBreve()
              this.progress = 100
            }
          }, 3000) // Ogni 3 secondi * 100 ingressi = 300 secondi = 5 minuti
        } else {
          if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
          }
        }
      },
      async onAssociaDispositivo() {
        this.mostraCodiceBreve = false
        this.mostraLinkAssociazione = true
        this.$emit('polling', true, this.codice)
      },
      generaCodiceBreve() {
        this.codiceBreve = crypto.randomBytes(4).toString('hex')
        const tipo = this.elencoAssociazioni[this.tab].type
        this.$emit('codice-breve', { licenseCode: this.codice, shortCode: this.codiceBreve, type: tipo })
      },
      onChangeTab() {
        this.mostraCodiceBreve = false
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }        
      },
      onAnnullaAssociaDispositivo() {
        this.$emit('polling', false, this.codice)
        this.mostraLinkAssociazione = false
      },
      onCancellaAssociazione() {
        this.dialogCancellaAssociazione = true
      },
      upmapConfirm() {
        this.$emit('unmap', this.codice)
        this.dialogCancellaAssociazione = false
      },
      unmapClose() {
        this.dialogCancellaAssociazione = false
      }
    }
  }
</script>
